/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlogDto } from '../../models/blog-dto';
import { BlogUpdateDto } from '../../models/blog-update-dto';

export interface BlogAdminControllerUpdateV1$Params {
  id: string;
      body: BlogUpdateDto
}

export function blogAdminControllerUpdateV1(http: HttpClient, rootUrl: string, params: BlogAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BlogDto>> {
  const rb = new RequestBuilder(rootUrl, blogAdminControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BlogDto>;
    })
  );
}

blogAdminControllerUpdateV1.PATH = '/api/v1/blogs/admin/{id}';
